export const BACK = 'Back';
export const CANCEL = 'Cancel';
export const CONTINUE_WITH_GOOGLE = 'Continue with Google';
export const NEXT = 'Next';
export const OK = 'OK';
export const RESEND_OTP = 'Resend OTP';
export const SUBMIT = 'Submit';
export const START = 'Start';
export const LOGIN = 'Login';
export const SIGN_UP = 'Sign Up';
export const GET_STARTED = 'Get started';
export const CREATE_PROGRAM = 'Create program';
